module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aberto),
      expression: "aberto"
    }],
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        return _vm.fecha(_vm.id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "side",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "side-content"
  }, [_c('div', {
    staticClass: "side-header"
  }, [_c('div', {
    staticClass: "side-close",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.fecha(_vm.id)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "side-title",
    attrs: {
      "id": (_vm.id + "-label")
    }
  }, [_vm._v(_vm._s(_vm.tit))])]), _vm._v(" "), _c('div', {
    staticClass: "side-subtitle",
    attrs: {
      "id": (_vm.id + "-sublabel")
    }
  }, [_vm._v(_vm._s(_vm.subtit) + "\n                "), _c('p', [_vm._v(_vm._s(_vm.subtDetl))])]), _vm._v(" "), _vm._t("default")], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-close-circle"
  }, [_c('div', {
    staticClass: "side-close-x"
  }, [_c('div', {
    staticClass: "side-close-x1"
  }), _vm._v(" "), _c('div', {
    staticClass: "side-close-x2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b889aae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/side-modal/side-modal.vue
// module id = PhhY
// module chunks = 5